import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import { Pill } from '../../../../shared/sso-workspace/pill'
import { EmptyState } from '../../../../shared/sso-workspace/fleet-page'
import { formatAgo, plural } from '../../../../shared/sso-workspace/format'
import { STATUS_LABEL, STATUS_TONE, groupTitle, where, fromLine } from './errors-format'

// The Errors list on phones (under 576 px): one card per group, 50 at a time.
// load(start, end) is the grid's row loader, so the cards read the same pages.
// One page loads at a time: a double tap on "Show more" asks once.
export const ErrorsCards = ({ load, selection }) => {
  const [rows, setRows] = useState([])
  const [count, setCount] = useState(0)
  const [loaded, setLoaded] = useState(false)
  const [loading, setLoading] = useState(false)
  const live = useRef(true)
  const inFlight = useRef(false)
  const loadedCount = useRef(0)
  useEffect(() => () => { live.current = false }, [])

  const more = async () => {
    if (inFlight.current) return
    inFlight.current = true
    setLoading(true)
    try {
      const start = loadedCount.current
      const page = await load(start, start + 50)
      if (!live.current) return
      const data = (page && page.data) || []
      loadedCount.current = start + data.length
      setRows(r => [...r, ...data])
      setCount(page ? page.count : 0)
      setLoaded(true)
    } finally {
      inFlight.current = false
      if (live.current) setLoading(false)
    }
  }
  useEffect(() => { more() }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="er-cards" data-testid="errors-cards">
      {loaded && rows.length === 0 && <EmptyState>Nothing matches these filters.</EmptyState>}
      {rows.map(g => (
        <article key={g.id} className="er-card">
          <div className="er-card-head">
            {selection && (
              <label className="er-select">
                <input type="checkbox" className="form-check-input" aria-label={`Select error ${g.id}`} checked={selection.isSelected(g.id)} onChange={() => selection.toggle(g.id)} />
              </label>
            )}
            <Link to={`/admin/errors/${g.id}`} className="er-card-title">{groupTitle(g)}</Link>
            <Pill tone={STATUS_TONE[g.status]}>{STATUS_LABEL[g.status] || g.status}</Pill>
          </div>
          <div className="sw-hint">{g.service} · <span className={g.source === 'request' ? 'sw-mono' : ''}>{where(g)}</span></div>
          {g.topFrom && <div className="er-card-from"><span className="er-chip" title={`Where most of its newest ${g.topFrom.samples} samples came from`}>{fromLine(g.topFrom)}</span></div>}
          <div className="er-card-meta">
            <span>{plural(g.totalCount || 0, 'event')}</span>
            <span>{plural(g.peopleCount || 0, 'person', 'people')}</span>
            <span>last seen {formatAgo(g.lastSeenAt)}</span>
          </div>
        </article>
      ))}
      {rows.length < count && <button type="button" className="btn sw-btn w-100" disabled={loading} onClick={more}>Show more</button>}
    </div>
  )
}
